/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_Formatting_SuccessInputs */



/**
* | output |
* | --- |
* | "Clear formatting completed successfully" |
*
* @param {Clear_Formatting_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const clear_formatting_success = /** @type {((inputs?: Clear_Formatting_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_Formatting_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacement de la mise en forme terminé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Formatierung erfolgreich abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancellazione formattazione completata con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить форматирование успешно завершено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar formato completado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("格式化已成功完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォーマットのクリアが正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पष्ट फ़ॉर्मेटिंग सफलतापूर्वक पूरी हो गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação clara concluída com sucesso")
	return /** @type {LocalizedString} */ ("Clear formatting completed successfully")
});